import React from 'react';
import PropTypes from 'prop-types';

class Divider extends React.PureComponent {
  render() {
    let { className } = this.props;

    return <hr className={className} />;
  }
}

Divider.propTypes = {
  className: PropTypes.string,
};

// TODO(next16): defaultProps removed in React 19 for function components.
// Convert to inline parameter defaults: const Divider = ({prop = val, className = '' }) =>

export default Divider;
